export default function getEnv() {
  return import.meta.env;
}
